import "react-native-gesture-handler";
import { Bootstrap } from "@grassrootly/rn-core";
import { ProjectFonts, ProjectThemes, defaultTheme } from "./src/layout";
import RootNavigation from "./src/navigation";
import APIReducers from "./src/api/CombinedAPIReducers";

export default function App() {
  return (
    <Bootstrap fonts={ProjectFonts} themes={{ initial: defaultTheme, options: ProjectThemes }} reducers={APIReducers}>
      <RootNavigation />
    </Bootstrap>
  );
}
